export const Logo = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect x="2" y="2" width="60" height="60" rx="16" fill="#C85A32" />
    <path d="M18 50V30a14 14 0 0 1 28 0v20" fill="none" stroke="#F7F4EE" strokeWidth="4" strokeLinecap="round" />
    <circle cx="32" cy="31" r="6" fill="#FFB347" />
    <path d="M14 50h36" stroke="#F7F4EE" strokeWidth="4" strokeLinecap="round" />
  </svg>
);
